import React from 'react';
import { Typography, Grid2, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { useSelector } from 'react-redux';
import contactImge from '../../assets/images/contactImage.png';
import { MainWrapper } from '../common-styles';
import { StaticData } from '../../config/enum/staticData';

const ContactUs: React.FC = () => {
    const { t } = useTranslation();
    const staticDataPayload = useSelector((state: any) => state?.staticDataState);
    const privacyPolicyData = staticDataPayload?.[StaticData.PRIVACY_POLICY];
    return (
        <MainWrapper height="auto !Important" p={{ xs: 1, lg: 5 }} sx={{ marginTop: 3 }}>
            <Grid2 container width="100%" className="contactUs">
                <Grid2 size={{ xs: 12, lg: 9 }} className="infoBox">
                    <Typography fontSize="24px" fontWeight={600}>
                        {' '}
                        {t('contact_information')}
                    </Typography>
                    <Typography variant="h5" fontFamily="good_sansregular" sx={{ fontSize: '14px' }}>
                        {t('contact_information_text')}
                    </Typography>
                    <Grid2
                        container
                        sx={{
                            flexDirection: 'row',
                            width: '100%',
                            justifyContent: 'center',
                            marginLeft: '50px',
                            marginTop: '24px',
                        }}
                    >
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Typography variant="h5">
                                <EmailIcon />{' '}
                                <Link target="_blank" href="mailto:support@WATTER.com" underline="none">
                                    {privacyPolicyData?.emailId}
                                </Link>
                            </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Typography variant="h5">
                                <InsertLinkIcon />
                                <Link
                                    target="_blank"
                                    className="cstLink"
                                    href={privacyPolicyData?.privacyPolicyLink}
                                    underline="always"
                                    sx={{
                                        textDecoration: 'underline !important', // force underline
                                        color: 'primary.main', // optional
                                    }}
                                >
                                    Terms and Conditions
                                </Link>
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }} display="flex" alignItems="center" justifyContent="center">
                    <img src={contactImge} alt="watter contact us" width="75%" />
                </Grid2>
            </Grid2>
        </MainWrapper>
    );
};
export default ContactUs;
